export enum EInsuranceStatus {
    Ok = 'ok',
    Expires = 'expires',
    Expired = 'expired',
}
